<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
@if (!(addresses$ | async)?.length && emptyListLabel) {
  <profile-pds-p-text p-text color="contrast-medium">
    {{ emptyListLabel }}
  </profile-pds-p-text>
}

@if (addresses$ | async; as addresses) {
  @if (addresses.length) {
    <div role="radiogroup" [attr.aria-label]="'pidpaw.selectAddress.list.aria.checkout' | translate">
      @for (address of addresses; track address) {
        <div class="profile:relative profile:not-first:mt-fluid-md" [attr.data-default-address]="address.isStandard">
          @if ((addressIdBeingEdited$ | async) !== address.addressId) {
            <div class="profile:ps-static-lg">
              <div class="profile:flex profile:pb-fluid-sm">
                @if (address.usage === 'work') {
                  <profile-pds-p-icon p-icon name="work" color="contrast-medium" size="2xs" aria-hidden="true"></profile-pds-p-icon>
                }
                @if (address.usage === 'home') {
                  <profile-pds-p-icon p-icon name="home" color="contrast-medium" size="2xs" aria-hidden="true"></profile-pds-p-icon>
                }
                <profile-pds-p-text p-text size="inherit" class="profile:text-[14px] profile:inline-block" color="contrast-medium"
                  >{{ getUsageString(address.usage ?? 'home') }} {{ getPrefixString(address.isStandard ?? false) }}</profile-pds-p-text
                >
              </div>
            </div>
            <div class="profile:flex profile:flex-col profile:md:flex-row profile:md:items-center profile:justify-between">
              <div class="profile:flex profile:flex-row">
                <profile-pds-p-radio-group
                  p-radio-group
                  state="none"
                  [value]="selectedAddressId$ | async"
                  (change)="selectItem(address.addressId ?? '')"
                  [disabled]="(radioListDisabled$ | async) ?? false"
                >
                  <profile-pds-p-radio-group-option
                    p-radio-group-option
                    name="radio_[{{ address.addressId }}-{{ instanceId }}]"
                    [attr.aria-labelledby]="'radio_[' + address.addressId + '-' + instanceId + ']'"
                    [value]="address.addressId ?? ''"
                  ></profile-pds-p-radio-group-option>
                </profile-pds-p-radio-group>
                <profile-pds-p-text
                  class="fs-exclude profile:ps-static-sm"
                  p-text
                  data-protractor-id="address-widget-list-formatted-address-content"
                  slot="label"
                  id="radio_[{{ address.addressId }}-{{ instanceId }}]"
                >
                  <span [innerHTML]="address.formattedAddress | pidxEscapeHtml | pidxNewLineTransform"></span>
                </profile-pds-p-text>
              </div>
              <div>
                <profile-pds-p-button-pure
                  p-button-pure
                  icon="edit"
                  (click)="editItem(address)"
                  [disabled]="(radioListDisabled$ | async) ?? false"
                  data-protractor-id="address-widget-edit-address-button"
                  class="profile:inline-block profile:ms-static-lg profile:md:ms-0 profile:py-fluid-sm"
                  [aria]="{ 'aria-label': editButtonAriaLabel(address) }"
                  >{{ editItemLabel }}</profile-pds-p-button-pure
                >
              </div>
            </div>
          }
          @if ((addressIdBeingEdited$ | async) === address.addressId) {
            <div class="profile:w-full">
              <myprofile-address-editform
                [instanceId]="instanceId ?? ''"
                [token]="token"
                [cancelButtonLabel]="'pidpaw.editAddress.button.cancel.label' | translate"
                [saveButtonLabel]="'pidpaw.editAddress.button.save.label' | translate"
                [saveAndContinueButtonLabel]="'pidpaw.editAddress.button.saveAndContinue.label' | translate"
                [deleteButtonLabel]="'pidpaw.editAddress.button.delete.label' | translate"
              ></myprofile-address-editform>
            </div>
          }
        </div>
      }
    </div>
  }
}
